module.exports = __webpack_public_path__ + "72a99a523c136bf94075d273ce13bf5f.MP3";